import { WorkflowRequests } from "./workflow-requests";

export function SelfWorkflowRequests() {
  return <WorkflowRequests requestType="self" />;
}
